import { render } from "./CardRailSkeleton.vue?vue&type=template&id=239503a2&scoped=true"
import script from "./CardRailSkeleton.vue?vue&type=script&lang=js"
export * from "./CardRailSkeleton.vue?vue&type=script&lang=js"

import "./CardRailSkeleton.vue?vue&type=style&index=0&id=239503a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239503a2"]])

export default __exports__